import Vue from "vue";

const state = () => ({
  shop: {},
  isOpen: false,
});

const getters = {
  isMenuOpen: (state) => {
    return state.isOpen;
  },
  getOverlayShop: (state) => {
    return state.shop;
  },
};

const actions = {
  updateOverlayShop({ commit }, shop) {
    commit("setOverlayShop", shop);
  },
  openMenu({ commit }) {
    commit("setIsOpen", true);
  },
  closeMenu({ commit }) {
    commit("setIsOpen", false);
  },
};

const mutations = {
  setOverlayShop(state, shop) {
    Vue.set(state, "overlayShop", shop);
  },
  setIsOpen(state, isOpen) {
    Vue.set(state, "isOpen", isOpen);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
